import * as Yup from "yup";

//REVISAR Y COMPLETAR AL MOMENTO DE CONECTAR CON MOBILE, CONOCER LAS VARIABLES Y TENER DISPONIBLES LOS ENDPOINTS

export const mobileConnectionsValidationSchema = Yup.object({
    company: Yup.object({ id: Yup.string().required("Requerido") }),
    urlMobile: Yup.string().matches(/^((https?:\/\/)|(www.))(?:([a-zA-Z]+)|(\d+\.\d+.\d+.\d+)):\d{4}$/,"La URL no es válida. Debe comenzar con 'http://', 'https://' o 'www', y ademas contener el número de puerto (ej. 'https://localhost:9090')").required("URL es requerido"),
    userMobile: Yup.string().required("Requerido"),
    passwordMobile: Yup.string()
    .min(8, "Contraseña debe contener al menos 8 caracteres")
    .matches(/\w/, "Contraseña debe contener al menos una letra")
    .matches(/\d/, "Contraseña debe contener al menos un número")
    .required("Requerido"),
    tokenMobile: Yup.string().required("Requerido"),
});
